export default __webpack_public_path__ + "static/media/1352.24c56bcb.png";